import 'angular:locale/data:sl';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "sl";
